import React from 'react';
import 'twin.macro';
import {
  useFieldsToDisplay,
  useSetFieldsToDisplay,
  useToggleFieldToDisplay,
} from './atom';
import { ButtonDisplay } from '@teetsh/app/src/components/Buttons/ButtonDisplay';
import { useSequenceCustomFieldDefinitions } from 'queries/sequences/customfields/useSequenceCustomFieldDefinitions';
import { useTranslation } from 'react-i18next';

export function FieldsToDisplay() {
  const fieldsToDisplay = useFieldsToDisplay();
  const setFieldsToDisplay = useSetFieldsToDisplay();
  const toggleField = useToggleFieldToDisplay();
  const { data: customFieldDefinitions = [] } =
    useSequenceCustomFieldDefinitions();
  const { t } = useTranslation();

  const availableFields = customFieldDefinitions.filter(cf =>
    cf.targets?.includes('fdpPhases'),
  );
  if (availableFields.length === 0) {
    return null;
  }

  return (
    <div tw="flex flex-wrap gap-2">
      {availableFields.map(field => (
        <ButtonDisplay
          onClick={() => {
            if (fieldsToDisplay === undefined) {
              // if fields to display has never been initialized, we display all fields (even if atom is undefined)
              // so we want to initialize it with everything but this one
              return setFieldsToDisplay(
                availableFields.map(cf => cf.id).filter(v => v !== field.id),
              );
            }
            return toggleField(field.id);
          }}
          active={
            fieldsToDisplay === undefined || fieldsToDisplay.includes(field.id)
          }
          key={field.id}
        >
          {field.name || t('sequence:pdf.customFieldWithNoName')}
        </ButtonDisplay>
      ))}
    </div>
  );
}
